import { Redirect } from "react-router-dom";
import React from "react";
import { connect } from "react-redux";

let mapStateToProps = (state) => {
  return {
    isAuth: state.auth.isAuth,
    lang: state.auth.lang,
  }
};


export const LoginRequired = (Component) => {
  class AnonymousRedirectComponent extends React.Component {
    render() {
      if (!this.props.isAuth) return <Redirect to={'/' + this.props.lang + '/my/login/'}/>
      return <Component {...this.props} />
    }
  }
  return connect(mapStateToProps)(AnonymousRedirectComponent)
}
